"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTimeStamps = function (timestamps, dockeys) {
    if (timestamps === null) {
        return null;
    }
    var newTimeStamps = __assign({}, timestamps);
    if (!newTimeStamps.createdAt) {
        if (dockeys.indexOf("createdAt")) {
            newTimeStamps.createdAt = "createdAt";
        }
        else if (dockeys.indexOf("created_at")) {
            newTimeStamps.createdAt = "created_at";
        }
    }
    if (!newTimeStamps.updatedAt) {
        if (dockeys.indexOf("updatedAt")) {
            newTimeStamps.updatedAt = "updatedAt";
        }
        else if (dockeys.indexOf("updated_at")) {
            newTimeStamps.updatedAt = "updated_at";
        }
    }
    return newTimeStamps;
};
exports.getDefaultSort = function (sortOptions) {
    var keys = Object.keys(sortOptions);
    return function (doc1, doc2) {
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var asc = sortOptions[key];
            if (!asc)
                continue;
            var val1 = doc1[key];
            var val2 = doc2[key];
            if (val1 < val2)
                return -asc;
            if (val1 > val2)
                return asc;
        }
        return 0;
    };
};
